import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@mui/system';
import ProScorePanel from '../proPanels/ProScorePanel';
import ProQuartileRank from '../proPanels/ProQuartileRank';
import PeerGroupDetails from '../proPanels/PeerGroupDetails';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { BenchmarkName } from '../text/BenchmarkName';

/**
 * Renders the Score tab for mobile, containing information about
 * the selected portfolio's peer group, EBAB score, and quartile rank.
 *
 * @component
 * @param {Object} selectedPortfolio - Currently selected portfolio
 * @param peerGroupData - Selected portfolio's peer group data
 * @returns {React.ReactElement} The rendered ScoreTab component
 */
const ScoreTab = ({ selectedPortfolio, peerGroupData }) => {
    return (
        <Stack spacing={2} data-analyticsid='portfolio-drilldown-header'>
            <Box sx={{ textAlign: 'center', padding: 2 }}>
                <Typography variant='header2'>
                    {selectedPortfolio?.portfolioLongName}
                </Typography>
                <BenchmarkName portfolioData={selectedPortfolio} />
            </Box>
            <PeerGroupDetails
                selectedPortfolio={selectedPortfolio}
                peerCount={peerGroupData?.count}
                isHorizontal={true}
            />
            <ProScorePanel selectedPortfolio={selectedPortfolio} />
            <Box paddingLeft={12} paddingRight={12}>
                <ProQuartileRank peerGroupData={peerGroupData} />
            </Box>
        </Stack>
    );
};

ScoreTab.propTypes = {
    selectedPortfolio: PropTypes.object,
    peerGroupData: PropTypes.object
};

export default ScoreTab;
